import { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";

function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim() || !/\S+@\S+\.\S+/.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    try {
      await addDoc(collection(db, "subscribers"), {
        email,
        subscribedAt: new Date(),
        status: "confirmed"
      });
      setEmail("");
      setSuccess("Thank you for subscribing!");
      setError("");
      setTimeout(() => setSuccess(""), 3000);
    } catch (err) {
      setError("Error subscribing. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card p-6 mb-12">
      <h2 className="text-2xl font-semibold text-text-light dark:text-text-dark mb-4">
        Join Our Newsletter
      </h2>
      <p className="text-neutral mb-4">
        Stay updated with tips, insights, and updates on your 66-day journey.
      </p>
      {error && (
        <p className="text-error mb-4">{error}</p>
      )}
      {success && (
        <p className="text-success mb-4 bg-success/10 dark:bg-success/20 p-2 rounded">{success}</p>
      )}
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="input flex-1"
          disabled={loading}
          aria-label="Newsletter email"
        />
        <button
          type="submit"
          className="btn-primary w-full sm:w-auto"
          disabled={loading}
          aria-label="Subscribe to newsletter"
        >
          Subscribe
        </button>
      </form>
    </div>
  );
}

export default NewsletterSignup;